import style from "./WhyList.module.css";
import online from "../images/icon-online.svg";
import simpleBudget from "../images/icon-budgeting.svg";
import fastOnboarding from "../images/icon-onboarding.svg";
import api from "../images/icon-api.svg";

const WhyList = () => {
  const listContainer = [
    {
      img :online,
      title: "Online Banking",
      paragraph:
        "Our modern web and mobile application allow you to keep track of your finances wherever you are in the world.",
    },
    {
      img :simpleBudget,
      title: "Simple Budgeting",
      paragraph:
        "See exactly where your money goes each month. Receive notifactions when you're close to your hitting limits.",
    },
    {
      img :fastOnboarding,
      title: "Fast Onboarding",
      paragraph:
        "We dont't do branches. Open you account in minutes online and start taking control of your finances right away.",
    },
    {
      img :api,
      title: "Open API",
      paragraph:
        "Manage your savings, investments, pension, and much more from one account. Tracking your money has never been easier.",
    },
  ];

  return (
    <div className={style.listContainer}>
        {
        listContainer.map(el=> 
      <article className={style.list} key={el.title}>
        <img src={el.img} alt="online Banking" />
        <h3 className={style.title}>{el.title}</h3>
        <p className={style.info}>{el.paragraph}</p>
      </article>
        )}        
    </div>
  );
};
export default WhyList;
